if (!customElements.get("product-vto")) {
  customElements.define(
    "product-vto",
    class ProductVTO extends ModalDialog {
      constructor() {
        super();

        this.vtoContent = this.querySelector(".vto-mobile-wrapper");
        this.loader = this.querySelector(".loading-overlay");
        this.swatches = this.querySelector(".YMK-swatchs");
        this.addToCart = this.querySelector("add-to-cart");
        this.ymkEventsBound = false;

        this.VirtualTryOnSdk = new VirtualTryOnSdk();

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const autoOpenButton = document.querySelector(
          ".main-product-section .button--vto",
        );
        if (urlParams.get("open-vto") && autoOpenButton) {
          this.show(
            autoOpenButton,
          );
        }

        this.addEventListener("click", (event) => {
          if (event.target.nodeName === "PRODUCT-VTO") this.hide();
        });
      }

      hide() {
        super.hide();
        if (this.VirtualTryOnSdk.isYMKModuleLoaded && window.YMK) {
          YMK.close();
        }
      }

      show(opener) {
        if (!opener || !opener?.dataset || !opener?.dataset?.sku) {
          return;
        }
        this.sku = opener.dataset.sku;
        super.show(opener);

        this.openModalVTO();
      }

      openModalVTO() {
        this.vtoContent.style.opacity = "1";
        this.openYMKModule();
      }

      openYMKModule() {
        this.VirtualTryOnSdk.createYMKDiv(this);
        if (this.VirtualTryOnSdk.isYMKModuleLoaded && window.YMK) {
          YMK.close();
          this.initEvents();
          YMK.openHandAR(true);
        } else {
          const hasStartedSdk = this.VirtualTryOnSdk.loadYMKModule(
            this,
            this.initEvents.bind(this),
          );

          if (!hasStartedSdk && this.loader) {
            this.loader.classList.add("hidden");
          }
        }
      }

      initEvents() {
        this.initSwatch();
        this.registerYMKEvents();
      }

      initSwatch() {
        if (!this.swatches) return;

        const inputs = this.swatches.querySelectorAll("input");
        if (!inputs.length) return;

        inputs.forEach((input) => {
          if (input.value == this.sku) {
            input.checked = true;
            this.initAddToCart(input);
            const swatchesList = this.swatches.querySelector("ul");
            const swatchItem = input.closest(".vto-swatch__item");
            if (swatchesList && swatchItem) {
              swatchesList.insertAdjacentElement("afterbegin", swatchItem);
            }
          }

          if (input.dataset.vtoBound === "true") return;

          input.dataset.vtoBound = "true";
          input.addEventListener("change", (evt) => {
            const el = evt.currentTarget;
            this.sku = el.value;
            this.initAddToCart(el);

            if (window.YMK) {
              YMK.applyMakeupBySku(this.sku);
            }
          });
        });
      }

      initAddToCart(el) {
        if (!this.addToCart || !el) return;

        this.toggleAddButton(true, "");
        this.addToCart.dataset.variantId = el.dataset.variantId;
        setTimeout(() => {
          if (el.dataset.productAvailable == "true") {
            this.toggleAddButton(false, "");
          } else {
            this.toggleAddButton(true, theme.variantStrings.soldOut);
          }
        }, 200);
      }

      toggleAddButton(disable = true, text) {
        if (!this.addToCart) return;

        if (disable) {
          this.addToCart.classList.add("disabled", true);
          if (text) this.addToCart.textContent = text;
        } else {
          this.addToCart.classList.remove("disabled");
          this.addToCart.textContent =
            this.addToCart.dataset.preOrder === "true"
              ? theme.variantStrings.preOrder
              : theme.variantStrings.addToCart;
        }
      }

      registerYMKEvents() {
        if (this.ymkEventsBound || !window.YMK) return;

        this.ymkEventsBound = true;

        YMK.addEventListener(
          "loading",
          function (progress) {
            const progressBar = this.loader?.querySelector('[role="progressbar"]');
            if (!progressBar) return;

            progressBar.style = "--value: " + progress;
          }.bind(this),
        );

        YMK.addEventListener(
          "loaded",
          function () {
            YMK.applyMakeupBySku(this.sku);
            if (this.swatches) {
              this.swatches.style.opacity = "1";
            }

            setTimeout(() => {
              if (this.loader) {
                this.loader.classList.add("hidden");
              }

              const moduleContainer = this.querySelector(
                ".YMK-module-container",
              );
              if (moduleContainer) {
                moduleContainer.style.opacity = "1";
              }
            }, 1000);
            // console.log('loaded VTO in modal');
          }.bind(this),
        );

        YMK.addEventListener(
          "closed",
          function () {
            if (this.loader) {
              this.loader.classList.remove("hidden");

              const progressBar = this.loader.querySelector(
                '[role="progressbar"]',
              );
              if (progressBar) {
                progressBar.style = "--value: 0";
              }
            }

            if (this.swatches) {
              this.swatches.style.opacity = "0";
            }
            // this.hide();
            // console.log('closed VTO in modal');
          }.bind(this),
        );

        YMK.addEventListener(
          "opened",
          function () {
            const moduleContainer = this.querySelector(".YMK-module-container");
            if (moduleContainer) {
              moduleContainer.style.opacity = "0";
            }
            // console.log('opened VTO in modal');
          }.bind(this),
        );
      }
    },
  );
}
